export default __webpack_public_path__ + "static/media/gallery_18.c2a5fc45.jpg";